import axios from '../../library/modules/axios'
const service = axios.service
export default service
